import { TaskListToolbar } from "../authoring-task-list"
import { ScheduleInfoNotes } from "../components/schedule-intro-notes"
import { ReadAllButton } from "./read-all-button"
import { TasksHeader } from "./tasks-header"

// TaskListToolbar("right").plug(<AuthoringTaskFilter if={(c) => !!c?.taskCount || !!c.isSimilarity} />)
TaskListToolbar("left").plug(<TasksHeader if={(c) => !!c?.taskCount} />)
// TaskListToolbar("left").plug(
//     <SearchBoxUsingSearchParam
//         sx={{ width: "85%", ml: 0 }}
//         placeholder="Search by task title..."
//         if={(c) => !!c?.isSimilarity}
//     />
// )
ScheduleInfoNotes.plug(<ReadAllButton if={(c) => !!c.overflowing} />)
